<template id="home-screen">
    <section>
        <div class="row">
            <div class="col-6">
                <h2><span>
              <i class="fa fa-cogs"></i>
                Configuration Screen</span>
                </h2>
            </div>
            <b-alert
                    :show="dismissCountDown"
                    dismissible
                    variant="Success"
                    @dismissed="dismissCountDown=0">
                Record Saved Successfully
            </b-alert>
            <b-alert
                    :show="dismissCountDownUpdated"
                    dismissible
                    variant="Warning"
                    @dismissed="dismissCountDown=0">
                Record Updated Successfully
            </b-alert>
            <div class="col-md-8 col-lg-12">
                <table v-if="showInput" class="table table-responsive">
                    <thead>
                    <tr align="center">
                        <th>Menu Level</th>
                        <th>Menu Name</th>
                        <th>Sub Menu Name</th>
                        <th>Viz Unit</th>
                        <th>Viz Name</th>
                        <th>Title</th>
                        <th>X1 Data Field</th>
                        <th>Metric Display</th>
                        <th>Visible Flag</th>
                        <th>Metric Unit</th>
                        <th>Metric Divisor</th>
                        <th>Data Source</th>
                        <th>Metric1 DataField</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><input type="number" v-model="config.menuLevel" class="form-control" v-b-tooltip.hover
                                   title="Only Numbers Can be Inserted"></td>
                        <td><input type="text" v-model="config.menuName" class="form-control"></td>
                        <td><input type="text" v-model="config.screenName" class="form-control"></td>
                        <td><input type="text" v-model="config.vizunit" class="form-control"></td>
                        <td><input type="text" v-model="config.vizname" class="form-control"></td>
                        <td><input type="text" v-model="config.title" class="form-control"></td>
                        <td><input type="text" v-model="config.x1_dataFieldName" class="form-control"></td>
                        <td><input type="text" v-model="config.metricDisplayName" class="form-control"></td>
                        <td><input type="text" v-model="config.visibleFlag" class="form-control"></td>
                        <td><input type="text" v-model="config.metricUnit" class="form-control"></td>
                        <td><input type="number" v-model="config.metricDivisor" class="form-control" v-b-tooltip.hover
                                   title="Only Numbers Can be Inserted"></td>
                        <td><input type="text" v-model="config.dataSource" class="form-control"></td>
                        <td><input type="text" v-model="config.metric1_dataFieldName" class="form-control"></td>
                        <td>
                            <b-button v-on:click="saveConfig(config)" variant="outline-primary" size="sm"
                                      v-b-tooltip.hover
                                      title="Save">
                                <i class="fa fa-save"></i>
                            </b-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <hr v-if="showInput">
        </div>
        <!--Filters-->
        <div class="form-row">
            <!--Filter by vizname-->
            <div class="col-md-2 col-lg-2">
                <label>Search by VizName</label>
                <v-select ref="select" :options="options1" v-model="search.vizname"
                          placeholder="Search to Select" label="Search by Title"></v-select>
            </div>
            <!--Filter by title-->
            <!-- <div class="col-md-2 col-lg-2">
                 <v-select ref="select" :options="options" v-model="search.title"
                           placeholder="Search to Select" label="Search by Title" multiple></v-select>
             </div>-->
            <div class="col-md-2 col-lg-3" style="margin-top: 22px">
                <b-button variant="outline-primary" v-on:click="generateReport(search.vizname)"
                          :disabled="vizunit === undefined || title === undefined"
                          v-b-tooltip.hover title="Generate">
                    <i class="fa fa-sync"></i>
                </b-button>
            </div>
            <div class="col-md-2 col-lg-3" style="margin-top: 22px">
                <b-button variant="outline-primary" v-b-tooltip.hover title="Add"
                          v-on:click="showRow()" style="float: right">
                    <i class="fa fa-plus"></i>
                </b-button>
            </div>
        </div>
        <div class="col-md-8 col-lg-12">
            <table class="table table-hover table-responsive-lg table-bordered">
                <thead class="thead-dark">
                <tr style="text-align: center">
                    <th>Menu Level</th>
                    <th>Menu Name</th>
                    <th>Screen Name Sub Menu Name</th>
                    <th>VizUnit</th>
                    <th>VizName</th>
                    <th>Title</th>
                    <th>X1 Data Field Name</th>
                    <th>Metric Display Name</th>
                    <th>Visible Flag</th>
                    <th>Metric Unit</th>
                    <th>Metric Divisor</th>
                    <th>Data Source</th>
                    <th>Metric1 DataField Name</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="s in screenConfig" :value="s" :key="s.id">
                    <td>{{s.menuLevel}}</td>
                    <td>{{s.menuName}}</td>
                    <td>{{s.screenName}}</td>
                    <td>{{s.vizunit}}</td>
                    <td>
                        <input type="text" v-if="showInputfield && s.id == editableId" v-model="s.vizname"
                               class="form-control">
                        <span v-else @click="edit(s.id)">{{s.vizname}}</span>
                    </td>
                    <td>
                        <input type="text" v-if="showInputfield && s.id == editableId" v-model="s.title"
                               class="form-control">
                        <span v-else @click="edit(s.id)">{{s.title}}</span></td>
                    <td>
                        <input type="text" v-if="showInputfield && s.id == editableId" v-model="s.x1_dataFieldName"
                               class="form-control">
                        <span v-else @click="edit(s.id)">{{s.x1_dataFieldName}}</span></td>
                    <td>
                        <input type="text" v-if="showInputfield && s.id == editableId" v-model="s.metricDisplayName"
                               class="form-control">
                        <span v-else @click="edit(s.id)">{{s.metricDisplayName}}</span></td>
                    <td>
                        <input type="text" v-if="showInputfield && s.id == editableId" v-model="s.visibleFlag"
                               class="form-control">
                        <span v-else @click="edit(s.id)">{{s.visibleFlag}}</span></td>
                    <td>
                        <input type="text" v-if="showInputfield && s.id == editableId" v-model="s.metricUnit"
                               class="form-control">
                        <span v-else @click="edit(s.id)">{{s.metricUnit}}</span></td>
                    <td>
                        <input type="number" v-if="showInputfield && s.id == editableId" v-model="s.metricDivisor"
                               class="form-control" v-b-tooltip.hover title="Only Numbers Can be Inserted">
                        <span v-else @click="edit(s.id)">{{s.metricDivisor}}</span></td>
                    <td>
                        <input type="text" v-if="showInputfield && s.id == editableId" v-model="s.dataSource"
                               class="form-control">
                        <span v-else @click="edit(s.id)">{{s.dataSource}}</span></td>
                    <td>
                        <input type="text" v-if="showInputfield && s.id == editableId"
                               v-model="s.metric1_dataFieldName"
                               class="form-control">
                        <span v-else @click="edit(s.id)">{{s.metric1_dataFieldName}}</span></td>
                    <td>
                        <div class="btn-group">
                            <div class="mt-0">
                                <b-button-group size="sm">
                                    <b-button variant="outline-warning" size="sm" v-b-tooltip.hover
                                              title="Edit" v-on:click="edit(s.id)">
                                        <i class="fa fa-edit"></i>
                                    </b-button>
                                    <b-button v-on:click="saveUpdate(s)"
                                              variant="outline-success" size="sm" v-b-tooltip.hover title="Save">
                                        <i class="fa fa-save"></i>
                                    </b-button>
                                </b-button-group>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <!--Table Ends-->
        <!-- </div>-->
    </section>
</template>
<script>
import axios from 'axios'

export default {
        name: 'home-screen',
        data: function () {
            return {
                searchUsername: '',
                config: [],
                showInput: '',
                showInputfield: '',
                search: [],
                screenConfig: [],
                vizname: [],
                s: [],
                configData: [],
                vizUnitData: [],
                vizunit: [],
                title: [],
                options: [],
                options1: [],
                dismissSecs: 1,
                dismissCountDown: 0,
                dismissCountDownUpdated: 0
            }
        },

        created: function () {
            //For Loading the Screen Config Data
            this.loadScreenConfig()
        },

        methods: {
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
            //Getting Data
            loadScreenConfig: function () {
                axios.get('/api/dashboard_screen/home/')
                    .then(res => {
                        this.screenConfig = res.data
                        this.vizname = Array.from(new Set(this.screenConfig.map(r => r.vizname).filter(s => s != null)))
                        this.title = Array.from(new Set(this.screenConfig.map(r => r.title).filter(s => s != null)))
                        this.options = this.title
                        this.options1 = this.vizname
                    })
            },

            //save function by passing a object
            saveConfig: function (config) {
                let payload = Object.assign({}, config)
                axios.post('api/dashboard_screen/home/', payload)
                    .then(response => {
                        console.log('Data Save Successfully', response)
                    }).then(() => this.loadScreenConfig()).catch(e => {
                    console.error('error in Saving Record', e)
                })
                this.dismissCountDown = this.dismissSecs

            },

            // Update Request Using Axios
            saveUpdate: function (s) {
                axios.put('/api/dashboard_screen/home/', s)
                    .then(response => {
                        console.log('Data Updated successfully', response)
                    }, error => {
                        console.error('error in saving to app', error)
                    })
                this.dismissCountDownUpdated = this.dismissSecs
            },

            //Sorting
            //Generate Report
            generateReport: function (vizunit, title) {
                console.log('Entered into Generate Report', vizunit, title)
                let url = '/api/vue-home-dashboard-test/' + this.search.vizname
                console.log('api for report is', url)
                axios.get(url)
                    .then(res => {
                        this.screenConfig = res
                        console.log('Getting Response for Parameter Passed from Backend:', this.screenConfig)
                    })
            },

            //Show Edit Input Field
            edit: function (id) {
                this.showInputfield = true
                this.editableId = id
            },

            //Show Row
            showRow: function (name) {
                console.log('showing row for ', name)
                this.showInput = true
            },
        },
    }
</script>
<style scoped>
    body {
        padding-top: 60px;
        font-size: 11px;
    }

    fieldset {
        box-shadow: 3px 2px 3px #a7aeaa;
        padding: 5px;
    }

    /*.table {
        font-size: 11px;
    }

    .table tr, .table td {
        height: 5px;
    }

    .table > tbody > tr > td, .table > tbody > tr > th, .table > tfoot > tr > td, .table > tfoot > tr > th, .table > thead > tr > td, .table > thead > tr > th {
        padding: 2px;
    }*/
</style>
